import React,{useEffect,useState} from 'react'
import './main.css'
import {useSelector,useDispatch} from 'react-redux'
import Quiz from './Quiz'
import NotAvailable from './NotAvailble'
import {
Spin,
} from 'antd'


function Index() {
   

    const user = useSelector(state=>state.user)
    const [userFetched,setUserFetched] = useState(true)
    const [questions,setQuestion] = useState(null)
    useEffect(()=>{
        if(user!==null){
            setUserFetched(false)
        }
    },[])

    
    return (
        <div id="main-container">
            {userFetched?
               <Spin size="large"/>:

               <div>
                    {user.verified?
                    <Quiz questions={questions}/>
                    :
                    <NotAvailable/>
                    
                    }

               </div>
            }

           
          
        </div>
    )
}

export default Index
